import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=b89a811c&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=ts"
export * from "./AppBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89a811c",
  null
  
)

export default component.exports